<div>
    <div class="breadcrumb-block">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link :to="{ name:'business-dashboard'}">Home</router-link>
                </li>
                <li aria-current="page" class="breadcrumb-item active">
                    Invoice Details
                </li>
            </ol>
        </nav>
    </div>
    <FlashMessage></FlashMessage>
    <div class="view-table">
        <div class="white-box pb-0">
            <div class="table-title">
                <div class="error-list" v-if="ui.error.error_message">
                    <ul class="error-msg">
                        <li :key="x" v-for="(error,x) in ui.error.error_message">
                            <div :key="i" v-for="(err,i) in error">
                                <p>{{err}}</p>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="container-fluid px-0">
                    <div class="row align-items-center">
                        <div class="col-lg-6" v-if="item.bookingData.trek.title">
                            <h4>{{item.bookingData.trek.title}}</h4>
                            <div class="depart-date" v-if="item.bookingData.departure.start_date">
                                <p>
                                    <i class="far fa-calendar-alt"></i> Departure:
                                    {{item.bookingData.departure.start_date}}
                                </p>
                            </div>
                        </div>
                        <div class="col-lg-6" v-else>
                            <h5>-</h5>
                        </div>
                        <div class="col-lg-6">
                            <div class="top-btn">
                                <a
                                        @click.prevent="downloadPdf"
                                        class="btn btn-primary btn-sm"
                                        download="abc"
                                        href="javascript:void(0)"
                                ><i class="fas fa-download"></i> Download as pdf</a
                                >
                                <a
                                        @click.prevent="showSendEmailModal"
                                        class="btn btn-success btn-sm"
                                        data-toggle="modal"
                                        href="javascript:void(0)"
                                >
                                    <i class="fas fa-envelope"></i> Send as email</a
                                >
                                <a class="btn btn-secondary btn-sm" href="javascript:void(0)"
                                ><i class="fas fa-print"></i> Print</a
                                >
                            </div>
                            `
                        </div>
                    </div>
                    <div class="manage-booking-table">
                        <div class="container-fluid px-0">
                            <div class="invoice-heading pb-0">
                                <h5>Invoice:</h5>
                            </div>
                            <hr/>
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="invoice-heading pt-0">
                                        <h5>To:</h5>
                                        <p class="mb-0" v-if="item.bookingData.customer.title">
                                            {{item.bookingData.customer.full_name}}
                                        </p>
                                        <p class="mb-0" v-if="item.bookingData.customer.email">
                                            {{item.bookingData.customer.email}}
                                        </p>
                                        <p class="mb-0" v-if="item.bookingData.customer.created_at">
                                            {{item.bookingData.customer.created_at}}
                                        </p>
                                        <p class="mb-0" v-if="item.bookingData.customer.contact_number">
                                            {{item.bookingData.customer.contact_number}}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="invoice-heading pt-0" v-if="item.bookingData.account">
                                        <h5>From:</h5>
                                        <p class="mb-0" v-if="item.bookingData.account.company_name">
                                            {{item.bookingData.account.company_name}}
                                        </p>
                                        <p
                                                class="mb-0"
                                                v-if="item.bookingData.account.company_contact_person"
                                        >
                                            {{item.bookingData.account.company_contact_person}}
                                        </p>
                                        <p
                                                class="mb-0"
                                                v-if="item.bookingData.account.company_address_line2 || item.bookingData.account.company_city || item.bookingData.account.company_country"
                                        >
                                            {{item.bookingData.account.company_address_line2}},
                                            {{item.bookingData.account.company_city}},
                                            {{item.bookingData.account.company_country}}
                                        </p>
                                        <p class="mb-0" v-if="item.bookingData.trek.created_at">
                                            {{item.bookingData.trek.created_at}}
                                        </p>
                                        <p class="mb-0" v-if="item.bookingData.account.company_zip">
                                            {{item.bookingData.account.company_zip}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="view-detail">
                            <div class="table-container">
                                <div class="table-responsive">
                                    <table class="table table-bordered" id="example">
                                        <thead class="table-light-bg">
                                        <tr>
                                            <th>Travellers detail</th>
                                            <th scope="col">Trek details</th>
                                        </tr>
                                        </thead>
                                        <tbody v-if="item.bookingData.trek">
                                        <tr class="booking-detail-row">
                                            <td v-if="item.bookingData.total_no_of_travellers">
                                                <table class="table-in w-100">
                                                    <tbody>
                                                    <tr>
                                                        <td>Total number of travelers:</td>
                                                        <td class="pl-5">
                                  <span
                                  >{{item.bookingData.total_no_of_travellers}}
                                    ({{item.bookingData.no_of_adult}} adult,
                                    {{item.bookingData.no_of_infant}} youth ,
                                    {{item.bookingData.no_of_youth}} infant)</span
                                  >
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                            <td v-else>Total number of travelers: -</td>
                                            <td v-if="item.bookingData.trek.title">
                                                Package name: <span>{{item.bookingData.trek.title}}</span>
                                            </td>
                                            <td v-else>Package name: -</td>
                                        </tr>
                                        <tr class="booking-detail-row">
                                            <td v-if="item.bookingData.no_of_adult">
                                                <span class="travler-title">Lead traveller:</span>
                                                <table class="inner-table">
                                                    <tbody>
                                                    <!-- <tr>
                                                      <td>Name</td>
                                                      <td><span>{{item.bookingData.customer}}</span></td>
                                                    </tr> -->
                                                    <tr>
                                                        <td>Name</td>
                                                        <td><span>{{item.bookingData.customer.full_name}}</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Email</td>
                                                        <td><span>{{item.bookingData.customer.email}}</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Country</td>
                                                        <td><span>{{item.bookingData.customer.country}}</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Date of birth</td>
                                                        <td><span>{{item.bookingData.customer.dob}}</span></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Passport number</td>
                                                        <td>
                                                            <span>{{item.bookingData.customer.passport_number}}</span>
                                                        </td>
                                                    </tr>
                                                    <!-- <tr>
                                                      <td>Passport number</td>
                                                      <td><span>{{item.bookingData.customer.passport_number}}</span></td>
                                                    </tr> -->
                                                    </tbody>
                                                </table>
                                            </td>

                                            <td v-if="item.bookingData.trek.duration">
                                                Duration: <span>{{item.bookingData.trek.duration}}</span>
                                            </td>
                                            <td v-else>Duration: -</td>
                                        </tr>
                                        <tr class="booking-detail-row">
                                            <td v-if="item.bookingData.no_of_adult">
                                                <span class="travler-title">Adult</span>
                                                <table class="inner-table">
                                                    <tbody>
                                                    <tr>
                                                        <td>Name</td>
                                                        <td><span>Prabhu Chaudhary</span></td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </td>

                                            <td v-if="item.bookingData.account.company_name">
                                                Tour operator:
                                                <span>{{item.bookingData.account.company_name}}</span>
                                            </td>
                                            <td v-else>Tour operator: -</td>
                                        </tr>
                                        <tr class="booking-detail-row">
                                            <td v-if="item.bookingData.no_of_youth">
                                                <span class="travler-title">Youth</span>
                                                <table class="inner-table">
                                                    <tbody>
                                                    <tr>
                                                        <td>Name</td>
                                                        <td><span>Prabhu Chaudhary</span></td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </td>

                                            <td>Trip difficulty: <span>Hard</span></td>
                                        </tr>
                                        <tr class="booking-detail-row-border">
                                            <td v-if="item.bookingData.no_of_infant">
                                                <span class="travler-title">Infant</span>
                                                <table class="inner-table">
                                                    <tbody>
                                                    <tr>
                                                        <td>Name</td>
                                                        <td><span>Prabhu Chaudhary</span></td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                            <td>
                                                <p class="sub-title" v-if="item.subTotal">
                                                    Subtotal:$ {{item.subTotal}}
                                                </p>
                                                <p class="sub-title" v-else>Subtotal:$ -</p>
                                            </td>
                                        </tr>
                                        <tr
                                                class="booking-detail-row"
                                                v-if="item.bookingData.saved_price>0"
                                        >
                                            <td class="empty-td"></td>
                                            <td>
                                                <p class="sub-title">
                                                    Discount: $ {{item.bookingData.saved_price}}
                                                </p>
                                                <!-- <p class="sub-title" v-else> Discount: $ 0.00</p> -->
                                            </td>
                                        </tr>
                                        <!-- <tr class="booking-detail-row">
                                          <td class="empty-td"></td>
                                          <td>
                                              <p class="sub-title"> Tax:2.5% </p>

                                          </td>
                                        </tr> -->
                                        <tr class="booking-detail-row-border">
                                            <td class="empty-td"></td>
                                            <td v-if="item.bookingData.total_price">
                                                <h4>Total amount: $ {{item.bookingData.total_price}}</h4>
                                            </td>
                                            <td v-else>
                                                <h4>Total amount: $ 0.00</h4>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-wrap">
                <!-- Modal -->
                <div
                        aria-hidden="true"
                        aria-labelledby="exampleModalLabel"
                        class="modal fade"
                        id="sendemail"
                        role="dialog"
                        tabindex="-1"
                >
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Send email</h5>
                                <button
                                        @click.prevent="hideSendEmailModal"
                                        aria-label="Close"
                                        class="close"
                                        type="button"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="error-list" v-if="ui.error.modal.email">
                                    <ul class="error-msg">
                                        <li :key="x" v-for="(error,x) in ui.error.modal.email">
                                            <div :key="i" v-for="(err,i) in error">
                                                <p>{{err}}</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="form-modified">
                                    <div class="form-wrap">
                                        <div class="form-group">
                                            <label for="">Enter email address</label>
                                            <input
                                                    :class="{ 'error-input' : ui.error.errors['email'] }"
                                                    class="form-control"
                                                    placeholder="Email address"
                                                    type="text"
                                                    v-model="item.emailData"
                                            />
                                        </div>
                                        <validation-error :errors="ui.error.errors" :field="'email'"
                                                          :isError="ui.error.has_error"
                                                          v-if="ui.error.has_error"/>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button
                                        :disabled="ui.status.postLoading.sendEmail"
                                        @click.prevent="sendEmailAction"
                                        class="btn default-btn"
                                        type="button"
                                >{{buttonTextSendEmail}}
                                    <spinner :loading="ui.status.postLoading.sendEmail" v-if="ui.status.postLoading.sendEmail"></spinner>
                                </button>
                                <button
                                        @click.prevent="hideSendEmailModal"
                                        class="btn default-btn cancel"
                                        type="button"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
